import { GetServerSideProps } from "next"
import { fetchInitials } from "queries"
import useQueryPlus from "utils/useQueryPlus"
import FeedPage from "views/feed"

export const getServerSideProps: GetServerSideProps = async ({ query }) => {
  return {
    props: {
      query,
    },
  }
}

const Feed = ({ query }: any) => {
  useQueryPlus({
    queryFn: fetchInitials,
    queryKey: ["initialApps"],
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    gcTime: Infinity,
    staleTime: Infinity,
  })
  return <FeedPage query={query} />
}
export default Feed
